<script>
export default {
  data() {
    return {
      path: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    if (
      
      this.path == "/patient_card_confUser_C" ||
      this.path == "/patient_card_selectuser"
    ) {
      if (!this.$route.query.clientId) {
        this.$router.push("/index");
        return;
      }
    }
  
  },
};
</script>